/* Cph Wheels live chat, "Spørg mig" (2026-10-16). Built after Autora's support chat.
 *
 * - A visitor starts with name, number plate and e-mail (required) and a link to the rims (optional; the
 *   link is filled in on a product page). The shop answers from the portal's Chat page or Telegram.
 * - The first time someone visits, the chat opens by itself after 30 seconds on the site (counted across
 *   pages, once per visitor). On a phone, where the chat fills the screen, a small message pops up instead.
 * - Open around the clock (data-always-open="1"). With fixed hours (weekdays 8-18 Copenhagen time) a new
 *   visitor outside them gets a contact form; a chat already running stays open, with a note.
 * - Polling: every 3 s while the panel is open, every 30 s while it is closed (unread badge). Every poll
 *   returns the whole conversation, which the widget redraws when it changed.
 * - The chat survives page loads: its id and the visitor's name are kept in localStorage.
 * - Text is always set with textContent; links are built as elements, never as HTML.
 * - Links to the contact page ("Kontakt", "kontakt os" ...) and to #chat open the chat instead.
 * - An AI assistant answers at once (owner, 2026-10-16). Its answers carry the label "AI-assistent", a note
 *   above the chat says so while it answers there, and "skriver …" shows while it writes (EU AI Act art. 50).
 */
(function () {
  "use strict";
  var root = document.getElementById("cw-chat");
  if (!root || root.getAttribute("data-ready")) return;
  root.setAttribute("data-ready", "1");

  var API = (root.getAttribute("data-api") || "").replace(/\/$/, "");
  var PRODUCT_URL = root.getAttribute("data-product-url") || "";
  var ALWAYS_OPEN = root.getAttribute("data-always-open") === "1";     // the owner: 24/7 (2026-10-16)
  var OPEN_HOUR = 8, CLOSE_HOUR = 18, HOURS_TEXT = "hverdage " + OPEN_HOUR + "-" + CLOSE_HOUR;
  var POLL_OPEN = 3000, POLL_CLOSED = 30000;
  var K_ID = "cw_chat_id", K_NAME = "cw_chat_name", K_SEEN = "cw_chat_seen";
  var K_FIRST = "cw_chat_first_visit", K_AUTO = "cw_chat_auto_done", AUTO_AFTER = 30000;  // owner, 2026-10-16
  var EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  var st = {
    open: false, id: load(K_ID), name: load(K_NAME), seen: parseInt(load(K_SEEN) || "0", 10) || 0,
    messages: [], pending: [], closed: false, timer: null, sig: "", view: "", assistant: false, typing: false
  };

  function load(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }
  function storageWorks() {
    try { localStorage.setItem("cw_chat_probe", "1"); localStorage.removeItem("cw_chat_probe"); return true; }
    catch (e) { return false; }
  }
  function save(key, value) {
    try { if (value == null || value === "") localStorage.removeItem(key); else localStorage.setItem(key, String(value)); }
    catch (e) { /* private mode: the chat still works on this page */ }
  }

  function isOpen(now) {
    if (ALWAYS_OPEN) return true;
    try {
      var parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Europe/Copenhagen", weekday: "short", hour: "2-digit", hour12: false
      }).formatToParts(now || new Date());
      var day = "", hour = 0;
      parts.forEach(function (p) {
        if (p.type === "weekday") day = p.value;
        if (p.type === "hour") hour = parseInt(p.value, 10) % 24;
      });
      return ["Mon", "Tue", "Wed", "Thu", "Fri"].indexOf(day) >= 0 && hour >= OPEN_HOUR && hour < CLOSE_HOUR;
    } catch (e) {
      return true;
    }
  }

  // --- DOM helpers ---------------------------------------------------------------------
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function linkified(text) {
    var frag = document.createDocumentFragment();
    String(text).split(/(https?:\/\/[^\s<>"]+)/g).forEach(function (part, i) {
      if (i % 2 === 1) {
        // "... her: https://…/tpms-sensor-id." - the full stop ends the sentence, not the link
        var tail = (part.match(/[.,;:!?)\]'’”“»«…]+$/) || [""])[0];
        var url = tail ? part.slice(0, -tail.length) : part;
        var a = el("a", null, url);
        a.href = url; a.target = "_blank"; a.rel = "noopener noreferrer nofollow";
        frag.appendChild(a);
        if (tail) frag.appendChild(document.createTextNode(tail));
      } else if (part) {
        frag.appendChild(document.createTextNode(part));
      }
    });
    return frag;
  }
  function field(label, name, opts) {
    opts = opts || {};
    var wrap = el("label", "cw-field");
    var caption = el("span", "cw-label", label);
    if (opts.optional) caption.appendChild(el("em", null, " (valgfri)"));
    wrap.appendChild(caption);
    var input = el(opts.multiline ? "textarea" : "input", "cw-input");
    input.name = name;
    if (!opts.multiline) input.type = opts.type || "text";
    if (opts.required) input.required = true;
    if (opts.placeholder) input.placeholder = opts.placeholder;
    if (opts.autocomplete) input.setAttribute("autocomplete", opts.autocomplete);
    if (opts.maxlength) input.maxLength = opts.maxlength;
    if (opts.value) input.value = opts.value;
    wrap.appendChild(input);
    if (opts.hint) wrap.appendChild(el("span", "cw-hint", opts.hint));
    return wrap;
  }
  function honeypot() {
    var trap = el("input", "cw-trap");
    trap.name = "website"; trap.type = "text"; trap.tabIndex = -1;
    trap.setAttribute("autocomplete", "off"); trap.setAttribute("aria-hidden", "true");
    return trap;
  }
  function pageUrl() { return location.href.split("#")[0]; }

  // --- the frame ------------------------------------------------------------------------
  var launch = el("button", "cw-launch");
  launch.type = "button";
  launch.setAttribute("aria-label", "Åbn chat med Cph Wheels");
  launch.setAttribute("aria-expanded", "false");
  launch.innerHTML =
    '<svg class="cw-icon-chat" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 4h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9l-5 4v-4H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/></svg>' +
    '<svg class="cw-icon-x" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
    '<span class="cw-launch-label">Spørg mig</span><i class="cw-live" aria-hidden="true"></i>';
  var badge = el("span", "cw-badge");
  badge.hidden = true;
  launch.appendChild(badge);

  var teaser = el("div", "cw-teaser");
  teaser.hidden = true;
  teaser.setAttribute("role", "status");
  teaser.appendChild(el("span", null, "Har du spørgsmål om fælge eller dæk til din bil? Skriv til os her."));
  var teaserX = el("button", "cw-teaser-x");
  teaserX.type = "button";
  teaserX.setAttribute("aria-label", "Luk beskeden");
  teaserX.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  teaser.appendChild(teaserX);

  var panel = el("div", "cw-panel");
  panel.hidden = true;
  panel.setAttribute("role", "dialog");
  panel.setAttribute("aria-labelledby", "cw-title");
  var head = el("div", "cw-head");
  var avatar = el("span", "cw-avatar", "CW");
  avatar.setAttribute("aria-hidden", "true");
  var titles = el("div", "cw-titles");
  var title = el("strong", null, "Cph Wheels");
  title.id = "cw-title";
  var status = el("span", "cw-status");
  titles.appendChild(title); titles.appendChild(status);
  var shut = el("button", "cw-shut");
  shut.type = "button";
  shut.setAttribute("aria-label", "Luk chatten");
  shut.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  head.appendChild(avatar); head.appendChild(titles); head.appendChild(shut);
  var body = el("div", "cw-body");
  panel.appendChild(head); panel.appendChild(body);

  root.appendChild(panel); root.appendChild(teaser); root.appendChild(launch);

  function setStatus(open) {
    status.textContent = "";
    status.appendChild(el("i", open ? "cw-dot cw-on" : "cw-dot"));
    status.appendChild(document.createTextNode(open ? "Online - vi svarer hurtigst muligt" : "Lukket - åbent " + HOURS_TEXT));
  }

  // --- API --------------------------------------------------------------------------------
  function api(method, path, payload) {
    var opts = { method: method, headers: {}, credentials: "omit" };
    if (payload) { opts.headers["Content-Type"] = "application/json"; opts.body = JSON.stringify(payload); }
    return fetch(API + path, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) { var err = new Error(data.error || "Noget gik galt. Prøv igen."); err.status = r.status; throw err; }
        return data;
      });
    });
  }

  // --- views ------------------------------------------------------------------------------
  function show(view) {
    st.view = view;
    body.textContent = "";
    if (view === "intro") renderIntro();
    else if (view === "offline") renderOffline();
    else if (view === "thanks") renderThanks();
    else renderChat(true);
  }

  function renderIntro() {
    var lead = el("p", "cw-lead", "Hej! Skriv dit navn og bilens nummerplade, så kan vi se, hvad der passer til din bil.");
    body.appendChild(lead);
    api("GET", "/status").then(function (d) {
      if (d.ai && lead.isConnected) lead.textContent += " Vores AI-assistent svarer dig med det samme, og en medarbejder tager over, når du beder om det.";
    }).catch(function () { /* the form works without it */ });
    var form = el("form", "cw-form");
    form.noValidate = true;
    form.appendChild(field("Navn", "name", { required: true, autocomplete: "name", maxlength: 60, value: st.name || "" }));
    form.appendChild(field("Nummerplade", "plate", { required: true, placeholder: "AB 12 345", maxlength: 12, autocomplete: "off" }));
    form.appendChild(field("E-mail", "email", { required: true, type: "email", autocomplete: "email", maxlength: 254,
      hint: "Så kan vi svare dig, også hvis du lukker siden." }));
    form.appendChild(field("Link til fælgen", "rim_url", { optional: true, type: "url", maxlength: 500, value: PRODUCT_URL,
      placeholder: "https://www.cphwheels.dk/products/…" }));
    form.appendChild(honeypot());
    var err = el("p", "cw-error"); err.setAttribute("role", "alert");
    var go = el("button", "cw-primary", "Start chat"); go.type = "submit";
    form.appendChild(err); form.appendChild(go);
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var f = form.elements, name = f.name.value.trim(), plate = f.plate.value.trim(), email = f.email.value.trim();
      if (!name) { err.textContent = "Skriv dit navn."; f.name.focus(); return; }
      if (plate.replace(/[\s\-.]/g, "").length < 2) { err.textContent = "Skriv bilens nummerplade, fx AB 12 345."; f.plate.focus(); return; }
      if (!EMAIL.test(email)) { err.textContent = "Skriv din e-mail, så vi kan svare dig."; f.email.focus(); return; }
      go.disabled = true; err.textContent = "";
      api("POST", "/start", { name: name, plate: plate, email: email, rim_url: f.rim_url.value.trim(),
        page_url: pageUrl(), website: f.website.value }).then(function (d) {
        if (!d.session_id) { go.disabled = false; return; }
        st.id = d.session_id; st.name = name; st.closed = false; st.messages = []; st.pending = []; st.seen = 0; st.sig = "";
        save(K_ID, st.id); save(K_NAME, name); save(K_SEEN, 0);
        show("chat");
        poll(true);
      }).catch(function (x) { go.disabled = false; err.textContent = x.message; });
    });
    body.appendChild(form);
    if (!st.quiet) setTimeout(function () { (form.elements.name.value ? form.elements.plate : form.elements.name).focus(); }, 50);
  }

  function renderOffline() {
    body.appendChild(el("p", "cw-lead", "Vi har lukket lige nu (åbent " + HOURS_TEXT + "), men skriv en besked, så vender vi tilbage hurtigst muligt."));
    var form = el("form", "cw-form");
    form.noValidate = true;
    form.appendChild(field("Navn", "name", { required: true, autocomplete: "name", maxlength: 60, value: st.name || "" }));
    form.appendChild(field("E-mail", "email", { required: true, type: "email", autocomplete: "email", maxlength: 254 }));
    form.appendChild(field("Nummerplade", "plate", { required: true, placeholder: "AB 12 345", maxlength: 12, autocomplete: "off" }));
    form.appendChild(field("Link til fælgen", "rim_url", { optional: true, type: "url", maxlength: 500, value: PRODUCT_URL }));
    form.appendChild(field("Besked", "message", { required: true, multiline: true, maxlength: 2000 }));
    form.appendChild(honeypot());
    var err = el("p", "cw-error"); err.setAttribute("role", "alert");
    var go = el("button", "cw-primary", "Send besked"); go.type = "submit";
    form.appendChild(err); form.appendChild(go);
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var f = form.elements;
      go.disabled = true; err.textContent = "";
      api("POST", "/offline", { name: f.name.value.trim(), email: f.email.value.trim(), plate: f.plate.value.trim(),
        rim_url: f.rim_url.value.trim(), message: f.message.value.trim(), page_url: pageUrl(), website: f.website.value
      }).then(function () {
        if (f.name.value.trim()) save(K_NAME, f.name.value.trim());
        show("thanks");
      }).catch(function (x) { go.disabled = false; err.textContent = x.message; });
    });
    body.appendChild(form);
  }

  function renderThanks() {
    body.appendChild(el("p", "cw-lead", "Tak! Vi vender tilbage hurtigst muligt."));
    var ok = el("button", "cw-primary", "Luk");
    ok.type = "button";
    ok.addEventListener("click", function () { toggle(false); });
    body.appendChild(ok);
  }

  var msgBox = null, input = null, sendBtn = null, notice = null, aiNote = null;

  function renderChat(fresh) {
    if (fresh || !msgBox) {
      body.textContent = "";
      notice = el("p", "cw-notice");
      aiNote = el("p", "cw-ai-note", "Du skriver med vores AI-assistent. Bed om en medarbejder, så tager en af os over.");
      msgBox = el("div", "cw-msgs");
      msgBox.setAttribute("aria-live", "polite");
      body.appendChild(notice);
      body.appendChild(aiNote);
      body.appendChild(msgBox);
      var bar = el("form", "cw-compose");
      input = el("textarea", "cw-input");
      input.rows = 1; input.maxLength = 2000; input.placeholder = "Skriv en besked …";
      input.setAttribute("aria-label", "Din besked");
      sendBtn = el("button", "cw-send", "Send"); sendBtn.type = "submit";
      bar.appendChild(input); bar.appendChild(sendBtn);
      bar.addEventListener("submit", function (e) { e.preventDefault(); send(); });
      input.addEventListener("keydown", function (e) {
        if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); }
      });
      input.addEventListener("input", function () {
        input.style.height = "auto";
        input.style.height = Math.min(input.scrollHeight, 120) + "px";
      });
      body.appendChild(bar);
      var restart = el("button", "cw-primary cw-restart", "Start ny chat");
      restart.type = "button";
      restart.addEventListener("click", reset);
      body.appendChild(restart);
      st.sig = "";
    }
    notice.textContent = isOpen() ? "" : "Vi har lukket nu (åbent " + HOURS_TEXT + "). Skriv bare, så svarer vi, når vi åbner.";
    notice.hidden = !notice.textContent;
    aiNote.hidden = !st.assistant || st.closed;
    drawMessages();
    body.querySelector(".cw-compose").hidden = st.closed;
    body.querySelector(".cw-restart").hidden = !st.closed;
    if (fresh && st.open && !st.closed) setTimeout(function () { input && input.focus(); }, 50);
  }

  function bubble(m) {
    var b = el("div", "cw-msg " + (m.sender === "admin" ? "cw-them" : "cw-me") + (m.ai ? " cw-ai" : "") +
      (m.failed ? " cw-failed" : ""));
    if (m.ai) b.appendChild(el("span", "cw-tag", "AI-assistent"));
    b.appendChild(linkified(m.body));
    var meta = el("small", null, m.failed ? "Ikke sendt" : (m.pending ? "Sender …" : clock(m.at)));
    b.appendChild(meta);
    return b;
  }
  function clock(at) {
    var d = at ? new Date(at) : new Date();
    if (isNaN(d)) d = new Date();
    return ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
  }

  function drawMessages() {
    if (!msgBox) return;
    var sig = st.messages.length + ":" + (st.messages.length ? st.messages[st.messages.length - 1].id : "") +
      ":" + st.pending.map(function (p) { return (p.failed ? "f" : "p") + p.body.length; }).join(",") + ":" + st.closed +
      ":" + (st.typing ? "t" : "");
    if (sig === st.sig) return;
    st.sig = sig;
    msgBox.textContent = "";
    msgBox.appendChild(bubble({ sender: "admin", body: "Hej " + (st.name || "") + "! Hvordan kan vi hjælpe dig?", at: null }));
    st.messages.forEach(function (m) { msgBox.appendChild(bubble(m)); });
    st.pending.forEach(function (m) { msgBox.appendChild(bubble(m)); });
    if (st.typing && !st.closed) {
      var dots = el("div", "cw-msg cw-them cw-ai cw-typing");
      dots.appendChild(el("span", "cw-tag", "AI-assistent"));
      dots.appendChild(document.createTextNode("skriver"));
      dots.appendChild(el("i")); dots.appendChild(el("i")); dots.appendChild(el("i"));
      msgBox.appendChild(dots);
    }
    if (st.closed) msgBox.appendChild(el("p", "cw-ended", "Chatten er afsluttet."));
    msgBox.scrollTop = msgBox.scrollHeight;          // redrawn only when something changed
  }

  function send() {
    var text = (input.value || "").trim();
    if (!text || !st.id || st.closed) return;
    var item = { sender: "visitor", body: text, pending: true };
    st.pending.push(item);
    input.value = ""; input.style.height = "auto";
    drawMessages();
    // ai: this widget labels the AI assistant's answers, so the server may let it answer
    api("POST", "/send", { session_id: st.id, body: text, ai: 1 }).then(function () {
      st.pending.splice(st.pending.indexOf(item), 1);
      poll(true);
    }).catch(function (x) {
      item.pending = false; item.failed = true;
      st.sig = "";
      drawMessages();
      if (x.status === 409 || x.status === 404) { st.closed = true; renderChat(false); }
      if (notice) { notice.textContent = x.message; notice.hidden = false; }
    });
  }

  // --- polling ----------------------------------------------------------------------------
  function adminCount() {
    return st.messages.filter(function (m) { return m.sender === "admin"; }).length;
  }
  function updateBadge() {
    var unread = st.open ? 0 : Math.max(0, adminCount() - st.seen);
    badge.textContent = unread > 9 ? "9+" : String(unread);
    badge.hidden = unread === 0;
  }
  function schedule() {
    clearTimeout(st.timer);
    if (!st.id || st.closed) return;
    st.timer = setTimeout(function () { poll(false); }, st.open ? POLL_OPEN : POLL_CLOSED);
  }
  function poll(now) {
    if (!st.id) return;
    clearTimeout(st.timer);
    api("GET", "/messages/" + encodeURIComponent(st.id)).then(function (d) {
      st.messages = d.messages || [];
      st.closed = d.status === "closed";
      st.assistant = !!d.assistant; st.typing = !!d.typing;
      if (st.open) { st.seen = adminCount(); save(K_SEEN, st.seen); }
      if (st.view === "chat") renderChat(false);
      updateBadge();
      schedule();
    }).catch(function (x) {
      if (x.status === 404) { forget(); if (st.open) show(isOpen() ? "intro" : "offline"); return; }
      schedule();
    });
  }
  function forget() {
    clearTimeout(st.timer);
    st.id = null; st.messages = []; st.pending = []; st.closed = false; st.seen = 0; st.sig = "";
    st.assistant = false; st.typing = false;
    save(K_ID, null); save(K_SEEN, null);
    updateBadge();
  }
  function reset() {
    forget();
    show(isOpen() ? "intro" : "offline");
  }

  // --- open and close ---------------------------------------------------------------------
  function toggle(force, quiet) {
    var open = typeof force === "boolean" ? force : !st.open;
    st.open = open;
    st.quiet = !!quiet;                     // opened by itself: no focus, no keyboard on a phone
    root.classList.toggle("cw-is-open", open);
    panel.hidden = !open;
    teaser.hidden = true;
    launch.setAttribute("aria-expanded", open ? "true" : "false");
    launch.setAttribute("aria-label", open ? "Luk chatten" : "Åbn chat med Cph Wheels");
    if (!open) { schedule(); updateBadge(); if (!quiet) launch.focus(); return; }
    save(K_AUTO, "1");                      // whoever opens it once is not surprised by it later
    var online = isOpen();
    setStatus(online);
    if (st.id) { show("chat"); poll(true); }
    else show(online ? "intro" : "offline");
    st.quiet = false;
    updateBadge();
  }

  launch.addEventListener("click", function () { toggle(); });
  teaser.addEventListener("click", function (e) {
    teaser.hidden = true;
    if (!(e.target.closest && e.target.closest(".cw-teaser-x"))) toggle(true);
  });

  // The first visit: open by itself after 30 seconds on the site (owner, 2026-10-16). The clock starts on
  // the first page and runs across pages; it fires once per visitor and never over a chat already going,
  // the cart, or a visitor whose browser keeps no storage (it would fire on every page). On a phone the
  // chat fills the screen, so a small message pops up instead: a full-screen pop-up while someone reads
  // is what Google counts against a page on mobile.
  function autoOpen() {
    if (load(K_AUTO) || st.id || st.open) return;
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkout|account)/i.test(location.pathname)) return;
    save(K_AUTO, "1");
    if (window.matchMedia && window.matchMedia("(max-width: 768px)").matches) { teaser.hidden = false; return; }
    toggle(true, true);
  }
  if (storageWorks() && !load(K_AUTO) && !st.id) {
    var first = parseInt(load(K_FIRST) || "0", 10);
    if (!first || first > Date.now()) { first = Date.now(); save(K_FIRST, first); }
    setTimeout(autoOpen, Math.max(0, first + AUTO_AFTER - Date.now()));
  }

  // Contact links open the chat (owner, 2026-10-16): "Kontakt" in the menu, "kontakt os" on the 404 page and
  // in page texts - every link to the contact page whose text speaks of contact - plus any link to #chat or
  // with data-cw-chat. A click with a modifier key still opens the page itself, for a new tab.
  var CONTACT_PATH = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/(?:kontakt|contact)\/?$/i;
  var SHOP_HOSTS = ["www.cphwheels.dk", "cphwheels.dk", "asfandyasin95.myshopify.com", location.hostname];
  function opensChat(a) {
    if (!a || a.hasAttribute("data-cw-chat") || a.getAttribute("href") === "#chat") return !!a;
    var url;
    try { url = new URL(a.getAttribute("href") || "", location.href); } catch (e) { return false; }
    return SHOP_HOSTS.indexOf(url.hostname) >= 0 && CONTACT_PATH.test(url.pathname) &&
      /kontakt/i.test(a.textContent || "");
  }
  document.addEventListener("click", function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
    if (!opensChat(a)) return;
    e.preventDefault();
    // A dropdown in the header closes; the mobile menu drawer stays, under the full-screen chat, because
    // closing it from here would leave the page's scroll lock behind.
    var menu = a.closest("details[open]");
    if (menu && !a.closest("header-drawer, menu-drawer")) menu.removeAttribute("open");
    toggle(true);
  }, true);
  window.cwChatOpen = function () { toggle(true); };
  shut.addEventListener("click", function () { toggle(false); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && st.open) toggle(false); });

  // A chat from an earlier page: keep the badge alive.
  if (st.id) poll(false);
})();
